import { render } from "./PRPMicroneedlingFacialContentEn.vue?vue&type=template&id=667719ff"
import script from "./PRPMicroneedlingFacialContentEn.vue?vue&type=script&lang=js"
export * from "./PRPMicroneedlingFacialContentEn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__